import 'primeicons/primeicons.css'
import './assets/main.css'
import './assets/layout.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'

import PrimeVue from 'primevue/config'
import ToastService from 'primevue/toastservice'
import ConfirmationService from 'primevue/confirmationservice'
import { shaganPreset } from '@shagan/theme'
import '@shagan/theme/brand.css'

import { registerSW } from 'virtual:pwa-register'

import App from './App.vue'
import { createRouter, createWebHistory } from 'vue-router'
import { routes, handleHotUpdate } from 'vue-router/auto-routes'
import { VueQueryPlugin, QueryClient } from '@tanstack/vue-query'
import i18n from './i18n'
import themeService from './services/themeService.ts'

// Тема применяется до монтирования — без вспышки светлой темы при старте.
themeService.applyStoredTheme()

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: routes,
})

const queryClient = new QueryClient()

createApp(App)
  .use(VueQueryPlugin, {
    queryClient,
  })
  .use(router)
  .use(i18n)
  .use(PrimeVue, {
    theme: {
      preset: shaganPreset,
      options: {
        darkModeSelector: '.app-dark',
        cssLayer: {
          name: 'primevue',
          order: 'base, primevue',
        },
      },
    },
  })
  .use(ToastService)
  .use(ConfirmationService)
  .use(createPinia())
  .mount('#app')

if (import.meta.hot) {
  handleHotUpdate(router)
}

// В dev своего service worker нет (vite-plugin-pwa собирает SW только в build). Но если
// на origin остался SW от прошлой build/preview-сборки — он кэширует ассеты и переживает
// обычный F5 (нужен Ctrl+F5, правки «не видны»). В dev активно снимаем любой SW и чистим
// кэши — тогда всегда свежая сборка + работает HMR, hard-refresh не нужен.
if (import.meta.env.DEV) {
  if ('serviceWorker' in navigator) {
    void navigator.serviceWorker
      .getRegistrations()
      .then((regs) => regs.forEach((r) => void r.unregister()))
  }
  if ('caches' in window) {
    void caches.keys().then((keys) => keys.forEach((k) => void caches.delete(k)))
  }
} else {
  // Прод: PWA-воркер в режиме autoUpdate — новый SW сам берёт контроль (skipWaiting+
  // clientsClaim), registerSW по событию `controlling` перезагружает страницу на свежую
  // сборку (обычный F5 = актуальная версия). registration.update() раз в минуту: открытая
  // вкладка узнаёт о новом деплое, не дожидаясь закрытия всех вкладок.
  registerSW({
    immediate: true,
    onRegisteredSW(_swUrl, registration) {
      if (registration) {
        setInterval(() => void registration.update(), 60_000)
      }
    },
  })
}
